import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';
import { ArrearsDecisionSummary, fetchDecisions } from '../../../../feature/arrearsDecisions';
import ROUTER_CONFIG from '../../../../router/router-config';

const money = (n: number) => `£${n.toFixed(2)}`;

export default function ArrearsDecisionsList({ campaignId }: { campaignId: string }) {
  const [decisions, setDecisions] = useState<ArrearsDecisionSummary[]>([]);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
    fetchDecisions(campaignId, 'pending').then(setDecisions).catch(() => setFailed(true));
  }, [campaignId]);

  if (failed) return <Wrap><Title>Could not load arrears decisions. Refresh the page to try again.</Title></Wrap>;
  if (decisions.length === 0) return null;

  return (
    <Wrap>
      <Title>Arrears decisions awaiting your review ({decisions.length})</Title>
      <Table>
        <thead>
          <tr><th>Parent</th><th>Students</th><th>Parent chose</th><th>Arrears</th><th>Waiting</th><th aria-label="actions" /></tr>
        </thead>
        <tbody>
          {decisions.map((d) => (
            <tr key={d.id}>
              <td>{d.parentName}</td>
              <td>{d.studentCodes.join(', ')}</td>
              <td>{d.optionLabel}{d.parentMessage ? <Message>“{d.parentMessage}”</Message> : null}</td>
              <td>{money(d.arrearsAmount)}</td>
              <td>{d.daysWaiting} days</td>
              <td>
                <ReviewLink to={ROUTER_CONFIG.SCHOOL_CAMPAIGN_ARREARS_DECISION.getPath({ campaignId, decisionId: String(d.id) })}>
                  Review
                </ReviewLink>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Wrap>
  );
}

const Wrap = styled.section`
  margin: 24px 0;
  padding: 16px 20px;
  border: 1px solid #F5C36B;
  border-radius: 8px;
  background: #FFF8EC;
`;
const Title = styled.h3`margin: 0 0 12px; font-size: 16px; color: #1F1F1F;`;
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  th, td { text-align: left; padding: 8px 6px; border-bottom: 1px solid #F0E2C6; vertical-align: top; }
  th { color: #6B7A87; font-weight: 600; }
`;
const Message = styled.div`color: #6B7A87; font-style: italic; margin-top: 4px;`;
const ReviewLink = styled(Link)`color: #2682DE; font-weight: 600;`;
